import { Component, OnInit, inject, ChangeDetectionStrategy, signal } from '@angular/core';
import { DatePipe } from "@angular/common";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {EntityHistoryService} from "../../services/entity-history.service";
import {Entity} from "../../entity/entity";
import {EntityHistory} from "../../model/entity-history";
import {StringUtils} from "../../utils/string-utils";
import {MatButton} from "@angular/material/button";

@Component({
  selector: 'app-entity-history-dialog',
  imports: [
    DatePipe,
    MatButton
],
  templateUrl: './entity-history-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './entity-history-dialog.component.css'
})
export class EntityHistoryDialogComponent implements OnInit {
  private dialogRef = inject<MatDialogRef<EntityHistoryDialogComponent>>(MatDialogRef);
  private readonly service = inject(EntityHistoryService);
  private readonly data = inject(MAT_DIALOG_DATA);


  private readonly entity: Entity;
  readonly entityId: string;
  readonly entityHistory = signal<EntityHistory>(undefined!);
  readonly errorMessage = signal<string>(undefined!);
  readonly isBusy = signal<boolean>(undefined!);

  constructor() {
    this.entity = this.data.entity;
    this.entityId = this.entity.id.entityId + ';' + this.entity.id.entityRevision;
  }

  ngOnInit(): void {
    this.isBusy.set(true);
    this.service.getEntityHistory(this.entity).subscribe({
      next: (history: EntityHistory) => {
        this.entityHistory.set(history);
        this.isBusy.set(false);
      }, error: (error: any) => this.handleError(error)
    });
  }

  private handleError(error: any) {
    this.isBusy.set(false);
    this.errorMessage.set(StringUtils.getErrorMessage(error));
  }

  close(): void {
    this.dialogRef.close();
  }

}
